import { render, staticRenderFns } from "./PageContact.vue?vue&type=template&id=21c73923&"
import script from "./PageContact.vue?vue&type=script&lang=js&"
export * from "./PageContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports